/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var moment = require('moment');

require('../styles/NonDepInternalApplicationGeneralInformationSectionView.css');
var tmplNonDepInternalApplicationGeneralInformationSectionView = require('../templates/NonDepInternalApplicationGeneralInformationSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepInternalApplicationGeneralInformationSectionView,

  className: 'non-dep-internal-application-general-information-section-view',

  onBeforeRender: function() {
    var submissionDate = this.model.get('submissionDate');
    var formattedDate = submissionDate ? moment(submissionDate, moment.ISO_8601).format('MM/DD/YYYY hh:mm a') : null;
    this.model.set({ submissionDate: formattedDate });
  }
});
